import type { ReactNode, SVGProps } from 'react';
import { useState } from 'react';
import styled, { css } from 'styled-components';
import { ReactComponent as EyeClosed } from '../../assets/icons/eye-crossed.svg';
import { ReactComponent as EyeOpen } from '../../assets/icons/eye.svg';
import { palette } from '../../theme/colors';
import { translate } from '../../utils/translate';
const STextField = styled.div<{ shadow?: boolean }>`
  display: flex;
  align-items: center;
  position: relative;
  ${props =>
    props.shadow &&
    css`
      box-shadow: ${props.theme.shadow.primary};
    `}
  width: 100%;
  border-radius: 0.93rem;
`;

type SInputParams = {
  isPasswordType: boolean;
  isStartAdronment: boolean;
};
const SInput = styled.input<SInputParams>`
  width: 100%;
  padding: 1rem;
  caret-color: ${palette.white};
  ${props =>
    props.isPasswordType &&
    css`
      padding-right: 3.5rem;
    `}
  ${props =>
    props.isStartAdronment &&
    css`
      padding-left: 3rem;
    `}
  background: ${palette.fadedDarkBlue};
  background-color: ${palette.fadedDarkBlue};
  border: 1px solid ${palette.siamiBlue};
  &:focus {
    border: 1px solid ${palette.siamiBlue};
    outline: 0;
  }
  &:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px ${palette.fadedDarkBlue} inset;
    -webkit-text-fill-color: ${palette.grayx11gray};
  }
  border-radius: 0.93rem;
`;
const SButton = styled.button`
  display: flex;
  position: absolute;
  background: none;
  border: none;
  right: 0.5rem;
  cursor: pointer;
`;

const SAdronment = styled.div`
  position: absolute;
  position: absolute;
  left: 1.3rem;
  max-width: 1.5rem;
  max-height: 2rem;
  overflow: hidden;
`;

export enum TextFieldType {
  TEXT = 'text',
  PASSWORD = 'password',
  EMAIL = 'email',
  URL = 'url',
}

type TextFieldProps = {
  type?: TextFieldType;
  touched?: boolean;
  placeHolderTx?: string;
  StartAdornment?: ReactNode | React.FC<SVGProps<SVGAElement>>;
  isShadow?: boolean;
} & Omit<
  React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
  'ref'
>;

export const TextField = (props: TextFieldProps) => {
  const {
    type = TextFieldType.TEXT,
    name,
    placeholder,
    value,
    onChange,
    onBlur,
    className,
    placeHolderTx,
    StartAdornment,
    isShadow = false,
    onClick,
    children,
    ...res
  } = props;
  const [passwordType, setPasswordType] = useState(TextFieldType.PASSWORD);

  const handleVisibility = () => {
    if (passwordType === TextFieldType.PASSWORD) {
      setPasswordType(TextFieldType.TEXT);
    } else {
      setPasswordType(TextFieldType.PASSWORD);
    }
  };

  const isStartAdronment = !!StartAdornment;
  const isPasswordType = type === TextFieldType.PASSWORD;

  const i18nPlacholder = placeHolderTx && translate(placeHolderTx);
  const placholderContet = i18nPlacholder || placeholder;

  return (
    <STextField shadow={isShadow} className={className} onClick={onClick} role="textFieldContainer">
      {StartAdornment && (
        <SAdronment role="adronment">
          <>{StartAdornment}</>
        </SAdronment>
      )}
      <SInput
        isPasswordType={isPasswordType}
        isStartAdronment={isStartAdronment}
        type={isPasswordType ? passwordType : type}
        name={name}
        placeholder={placholderContet}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        {...res}
        role="input"
      />
      {isPasswordType && (
        <SButton type="button" onClick={handleVisibility} role="toggleVisibilityButton">
          {passwordType === TextFieldType.TEXT ? (
            <EyeOpen role="openIcon" />
          ) : (
            <EyeClosed role="closedIcon" />
          )}
        </SButton>
      )}
    </STextField>
  );
};
